import { render, staticRenderFns } from "./FoodGroup.vue?vue&type=template&id=984cd962&"
import script from "./FoodGroup.vue?vue&type=script&lang=js&"
export * from "./FoodGroup.vue?vue&type=script&lang=js&"
import style0 from "./FoodGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports